module.exports = __webpack_public_path__ + "img/WMSfour.858c2910.png";